import { Component, ElementRef, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CognitoService } from "src/app/shared/services/cognito.service";
import {
  showError,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";
import { CoreApiService } from "src/app/core/core-api.service";
import { PasswordValidator } from "src/app/portal/utils/password-validator";
import { TokenStatus } from "src/app/shared/components/token-input/token-input.component";

@Component({
  selector: "app-lost-password",
  templateUrl: "./lost-password.component.html",
  styleUrls: ["./lost-password.component.scss"],
})
export class LostPasswordComponent implements OnInit {
  formForgotPassword: FormGroup;
  formPasswordToken: FormGroup;

  etapas: number = 1;
  currentYear: string = '2023'

  username: string;
  email: string;

  userEmailMasked: string = '';
  codigoInvalido: boolean = false;

  mostrarSenha = false;
  mostrarConfirmarSenha = false;

  checarSenha = {
    minLength: false,
    uppercase: false,
    specialCharacter: false,
    number: false
  };

  tokenStatus: TokenStatus = "idle";
  validating = false;

  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private coreApiService: CoreApiService,
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear().toString()
    this.createFormForgotPassword();
    this.createFormPasswordToken();
  }

  send() {
    if (this.formForgotPassword.valid) {
      this.username = this.document.value;

      this.cognitoService.resetPassword(this.username).subscribe(
        (resp) => {
          const parsedResp = typeof resp === 'string' ? JSON.parse(resp) : resp;

          if (parsedResp && parsedResp.CodeDeliveryDetails) {
            this.userEmailMasked = parsedResp.CodeDeliveryDetails.Destination;
          }

          if (!this.coreApiService.isJson(resp)) {
          this.etapas = 2;
          } else {
            showError("", JSON.parse(resp).descricaoErro[0])
          }
        },
        (e) => {
          showError("", e.message);
        }
      )
      ,
      (e) => {
        showError("", e.message);
      }
    } else if (this.document?.value == null || this.document?.value == '') {
      return showError(
        "",
        "O campo Documento Identificador não pode ser vazio."
      )
    } else{
      return showError(
        "Não encontramos o seu cadastro",
        "Verifique se o CPF ou CNPJ informado está correto e tente novamente.",
        { confirmButtonText: "Tentar novamente" }
      );
    }
  }

  resendEmailCode() {
    this.cognitoService.resetPassword(this.username).subscribe(
      (res) => {
        return showSucess(
          "",
          "Um novo token foi enviado para o email informado."
        );
      },
      (e) => {
        return showError("", e.message);
      },
      () => {}
    );
  }

  validatePassword() {
    if (!this.senhaForte) {
        return showError(
          "",
          "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
        );
    }

    if (!this.senhaCorresponde) {
      return showError("", "As senhas informadas não coincidem");
    }

    if (this.token?.value == null || this.token.value.length < 6) {
      this.codigoInvalido = true;
      return showError(
        "",
        "Valide as informações do formulário para prosseguir."
      );
    }

    this.validating = true;
    this.tokenStatus = "idle";

    return this.cognitoService
      .confirmPassword(this.username, this.newPassword.value, this.token.value)
      .subscribe(
        (res) => {
          this.validating = false;
          this.tokenStatus = "success";

          setTimeout(() => {
            this.router.navigate(["login"]);
            showSucess("", "Senha alterada com sucesso", {
              confirmButtonText: "Acessar conta"
             });
          }, 800);
        },
        (e) => {
          this.validating = false;

          if (this.tokenError(e)) {
            this.tokenStatus = "error";
          } else {
            this.tokenStatus = "idle";
            showError("", e.message);
          }
        }
      );
  }

  private tokenError(e: any): boolean {
    const codigo = e?.code || e?.name || '';
    return [
      "CodeMismatchException",
      "ExpiredCodeException",
    ].includes(codigo);
  }

  createFormPasswordToken() {
    this.formPasswordToken = new FormGroup({
      token: new FormControl("", [
        Validators.required,
        Validators.minLength(6),
      ]),
      newPassword: new FormControl("", [
        Validators.required,
        PasswordValidator.strong,
        Validators.minLength(8),
      ]),
      confirmNewPassword: new FormControl("", [Validators.required]),
    });
  }

  createFormForgotPassword() {
    this.formForgotPassword = new FormGroup({
      document: new FormControl("", [
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(14),
      ]),
    });
  }

  backStep() {
    return this.router.navigate(["/login"]);
  }

  cancelarVoltar() {
    this.etapas = 1;
    this.formForgotPassword.reset();
    this.formPasswordToken.reset();
  }

  checkSenha() {
    const senha: string = this.newPassword.value || '';

    this.checarSenha = {
      minLength: senha.length >= 8,
      uppercase: /[A-Z]/.test(senha),
      specialCharacter: /[^A-Za-z0-9]/.test(senha),
      number: /\d/.test(senha)
    }
  }

  statusSenha() {
    this.checarSenha = {
      minLength: false,
      uppercase: false,
      specialCharacter: false,
      number: false
    }
  }

  get requisitosSenha(): number {
    return Object.keys(this.checarSenha).filter((k) => this.checarSenha[k]).length;
  }

  get senhaForte(): boolean {
    return this.requisitosSenha === 4;
  }

  get nivelSenha(): 'vazia' | 'fraca' | 'media' | 'forte' {
    if (!this.newPassword.value) { return 'vazia'; }
    if (this.requisitosSenha <= 2) { return 'fraca'; }
    if (this.requisitosSenha === 3) { return 'media'; }
    return 'forte';
  }

  get labelForca(): string {
    const labels = { vazia: '', fraca: 'Fraca', media: 'Média', forte: 'Forte' };
    return labels[this.nivelSenha];
  }

  get confirmacaoPreenchida(): boolean {
    return !!this.confirmNewPassword.value;
  }

  get senhaCorresponde(): boolean {
    return this.confirmacaoPreenchida && this.newPassword.value === this.confirmNewPassword.value;
  }

  get podeSalvar(): boolean {
    return this.senhaForte && this.senhaCorresponde && !this.token?.invalid;
  }

  get document() {
    return this.formForgotPassword.get("document");
  }

  get token() {
    return this.formPasswordToken.get("token");
  }

  get newPassword() {
    return this.formPasswordToken.get("newPassword");
  }

  get confirmNewPassword() {
    return this.formPasswordToken.get("confirmNewPassword");
  }
}
